export const HYDRATE_AIRCRAFT_VARIANTS = "HYDRATE_AIRCRAFT_VARIANTS";
export const HYDRATE_AIRCRAFT_VARIANTS_PENDING = "HYDRATE_AIRCRAFT_VARIANTS_PENDING";
export const HYDRATE_AIRCRAFT_VARIANTS_FULFILLED = "HYDRATE_AIRCRAFT_VARIANTS_FULFILLED";
export const HYDRATE_AIRCRAFT_VARIANTS_REJECTED = "HYDRATE_AIRCRAFT_VARIANTS_REJECTED";

export const SELECT_AIRCRAFT_VARIANT = "SELECT_AIRCRAFT_VARIANT";

export const RESET_AIRCRAFT_VARIANTS = "RESET_AIRCRAFT_VARIANTS";
